export const isNumericValue = (value: any) => value !== '' && !isNaN(Number(value));
